require('core-js');
require("regenerator-runtime/runtime");
require('bootstrap');
require('bootstrap-star-rating');

$.fn.rating.defaults.showCaption = false;
$.fn.rating.defaults.showCaptionAsTitle = false;
$.fn.rating.defaults.showClear = false;
$.fn.rating.defaults.emptyStar = '<i class="glyphicon glyphicon-star"></i>';
$.fn.ratingThemes['krajee-uni']['emptyStar'] = '&#x2605;';